<template>
<div
  id="direct-debit-sendbox"
  class="page page-on-center"
  data-page="sendbox-page" @ptr:refresh="onRefresh(false)">

    <div class="showSmallScreenOnly" v-bind:class="colorBottomButton">
      <f7-fab class="leftfav2 button-fab bottomButton floatingButtonToolbarBlank" @click="openCreateRequest">
        <f7-icon f7="add"></f7-icon>
        <!--<span class="showLargeScreenOnly fab-label">Create new request</span>-->
      </f7-fab>
      <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank" @click="extractCSV(sendboxMessages)">
        <f7-icon f7="document_text"></f7-icon>
      </f7-fab>
    </div>

    <div class="page-content filterHeight heightifLargeScreen"
         style="z-index:9;">

      <div class="pull-to-refresh-layer">
        <div class="preloader"></div>
        <div class="pull-to-refresh-arrow"></div>
      </div>

    <div class="row rowBackgroundImage showLargeScreenOnly">
      <div class="row rowSearchBar" v-bind:class="colorBottomButton">
        <div class="firstButtonMarginLeft showLargeScreenOnly">
          <button class="new-button milkyBlock boxRequest" @click="openCreateRequest">
            <f7-icon f7="add"></f7-icon>
            <span>Create new request</span>
          </button>
        </div>
        <div class="">
          <button class="new-button milkyBlock pull-right" @click="extractCSV(sendboxMessages)">
            <f7-icon f7="document_text"></f7-icon>
            <span>Extract CSV</span>
          </button>
        </div>
      </div>
    </div>

    <div class="searchFilter searchFilterWithoutTabs">
  		<!-- <cm-messages-filter
        class=""
        style="position:relative;z-index:10"
        :isPayments="true"
        :received="false">
      </cm-messages-filter> -->

      <page-nav-bar
        v-bind:currentServiceName="serviceName"
        popoverName=""
        subNavTitle="Sent Modular Loan Requests"
        :menuAccess="true"
        :paymentsNumber="directDebitNumber">
      </page-nav-bar>

      <div class=" infinite-scroll pull-to-refresh-content "
      style="z-index:9"
      @infinite="onInfinite">

        <transactions-list
          :filterBy="filterBy"
          v-bind:outMessages="sendboxMessages">
        </transactions-list>
        <div class="toolbarPageBottomBlank"></div>

      </div>
    </div>
    </div>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import TransactionsList from '@/pages/requests/TransactionsList.vue'
import MessagesFilter from '@/components/common/Filter.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

var loading = false

export default {
  name: 'Sentbox',
  components: {
    'page-nav-bar': pageNavBar,
    'transactions-list': TransactionsList,
    'cm-messages-filter': MessagesFilter,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      serviceName: 'MoneyRoad',
      sendboxMessages: [],
      sendboxDir: 1,
      pageCounter: 0,
      noMoreMessages: false,
      newRequest: 1,
      scrollDown: false,
      noMore: false,
      filterBy: '',
      afterBack: false,
      directDebitNumber: ''
    }
  },
  beforeMount () {
    /* let that = this
    this.$f7.onPageAfterBack('details-page', function (page) {
      that.afterBack = true
    }) */
  },
  mounted () {
    this.$$('.panel-overlay').css('z-index', '1')
  },
  created () {
    // let that = this
    // this.sendboxMessages = []
    // this.$f7.params.swipePanel = 'left'
    // // that.$engine.services.payments.filter.status = ''
    // // that.$engine.services.payments.filter.date = ''
    // // that.$engine.services.payments.filter.creditorOrDebtorName = ''
    // /* Turn off all buses events */
    // // this.$bus.$off('refresh-cache-service')
    // this.$bus.$off('refresh-cache-bank-accounts')
    // this.$bus.$off('refresh-cache-contacts')
    // // this.$bus.$off('refresh-cache-attachments-view')
    // this.$bus.$off('refresh-cache-attachments')
    // this.$bus.$off('refresh-cache-account-members')
    // // TODO: changement
    // this.$bus.$off('refresh-sendbox-list-cache')
    // this.$bus.$off('refresh-inbox-on-seen')
    // this.$bus.$off('sendbox-filtered')
    // this.$bus.$on('sendbox-filtered', payments => {
    //   that.updateSendbox(payments)
    //   that.pageCounter = 0
    // })
    // this.$bus.on('refresh-sendbox-on-seen', (refPays) => {
    //   that.updateSendbox(refPays, true)
    //   loadPage(that, {url: '/payments/transaction-details/'})
    // })
    // this.$f7.initPullToRefresh()
    // this.$engine.settings.set({msgDirection: 1})
    // this.$engine.settings.set({filterType: ''})
    // this.$engine.settings.set({filterValue: ''})
    // this.pageCounter = 0
    // if (this.$engine.user.getIsFirstLogin() === '1') {
    //   this.$engine.user.setIsFirstLogin('0')
    //   that.$f7.openPanel('left')
    //   that.$engine.services.payments.getPaymentsNotReadNumber()
    //   .then(resp => {
    //     if (resp.data.requestNotReadNumber > 99) {
    //       that.Dom7('.numberBadge').text('99+')
    //     } else {
    //       that.Dom7('.numberBadge').text(resp.data.requestNotReadNumber)
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
    // }
    // TODO
    // this.$engine.services.payments.filter.status = ''
    // this.$engine.services.payments.filter.negotiationStatus = ''
    // this.$engine.services.payments.filter.dateBegin = ''
    // this.$engine.services.payments.filter.dateEnd = ''
    // this.$engine.services.payments.filter.creditorOrDebtorName = ''
    // this.$engine.services.payments.filter.reference = ''
    this.onRefresh(true)
  },
  beforeDestroy () {
    // let that = this
    // this.$engine.settings.set({status: null})
    // this.$engine.settings.set({date: null})
    // this.$engine.settings.set({cdtrOrDbtrNm: null})
    // this.$bus.$off('sendbox-filtered')
    // this.$bus.$off('refresh-sendbox-list-cache')
    this.$f7.onPageAfterBack('details-page', function (page) {}).remove()
    // that.$engine.services.payments.filter.status = ''
    // that.$engine.services.payments.filter.dateBegin = ''
    // that.$engine.services.payments.filter.dateEnd = ''
    // that.$engine.services.payments.filter.creditorOrDebtorName = ''
    // that.$engine.services.payments.filter.negotiationStatus = ''

    // that.$engine.services.payments.filter.cleanFilterCondition()
  },
  computed: {
    emptyBox () {
      return this.sendboxMessages.length === 0
    }
  },
  methods: {
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({sendboxPreloaderRemoved: true})
      if (!this.emptyBox) this.noMore = true
    },
    attachInfinit () {
      if (this.$settings.sendboxPreloaderRemoved) {
        this.$$('.infinite-scroll').append(
        '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({sendboxPreloaderRemoved: false})
      } else {
      }
      this.noMore = false
    },
    onInfinite: function (event) {
      let that = this
      if (loading) return
      loading = true
      loading = false
      that.pageCounter = that.pageCounter + 1
      that.$engine.services.directDebit.update(1, 10, that.pageCounter * 10 + 1, that.$engine.services.directDebit.filter.getConditionObject())
      .then(resp => {
        this.directDebitNumber = resp.data.totalDirectDebits
        let directDebits = resp.data.directDebits
        if (directDebits.length > 0) {
          for (let i = 0; i < directDebits.length; i++) {
            that.sendboxMessages.push(directDebits[i])
          }
          if (directDebits.length < 10) {
            that.detachInfinit()
          }
        } else {
          that.detachInfinit()
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRefresh: function (noAttach) {
      const that = this
      this.pageCounter = 0
      this.scrollFlag = true

      that.$engine.services.directDebit.update(1, 15, 1, that.$engine.services.directDebit.filter.getConditionObject())
      .then(resp => {
        // console.log('ML REFRESH RESP')
        // console.log(resp.data.directDebits)
        this.directDebitNumber = resp.data.totalDirectDebits
        this.updateSendbox(resp.data.directDebits, noAttach)
        that.$f7.pullToRefreshDone()
        // that.$f7.hidePreloader()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    updateSendbox (directDebits, noAttach = false) {
      this.sendboxMessages = directDebits
      if (directDebits.length === 10) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    onClear: function (event) {
      this.filterBy = ''
      this.attachInfinit()
    },
    onEnable: function (event) {
      this.detachInfinit()
    },
    onDisable: function (event) {
      this.attachInfinit()
    },
    OpenFormsPage () {
      const that = this
      that.$f7.popup('.forms-page')
    },
    openCreateRequest () {
      loadPage(this, {url: '/directDebit/creation/'})
    }
  }
}
</script>

<style scoped>
  @media (min-width: 993px) {
    .searchForm {
      margin-top: 0%;
    }
  }
  .milkyBlock.boxRequest.pull-right.new-button {
    width: 125px;
  }

  .rowBackgroundImage {
    background-image: url('../../../assets/static/images/MenuFont.png');
    background-size: contain;
  }
</style>



// WEBPACK FOOTER //
// SendboxPage.vue?50acdbd6